import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
  standalone: false,
})
export class SearchComponent {
  constructor() {}

  @Output() filter: EventEmitter<string> = new EventEmitter<string>();

  protected search: string;

  protected updateSearch(): void {
    console.log('update');

    this.filter.emit(this.search);
  }
}
